var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKvacica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.70711 4.79289C1.31658 4.40237 0.683417 4.40237 0.292893 4.79289C-0.0976311 5.18342 -0.0976311 5.81658 0.292893 6.20711L1.70711 4.79289ZM5.5 10L4.79289 10.7071C4.98393 10.8981 5.24414 11.0038 5.51428 10.9999C5.78442 10.996 6.04151 10.883 6.22701 10.6866L5.5 10ZM14.727 1.68662C15.1062 1.28511 15.0881 0.652199 14.6866 0.272987C14.2851 -0.106225 13.6522 -0.0881418 13.273 0.313376L14.727 1.68662ZM0.292893 6.20711L4.79289 10.7071L6.20711 9.29289L1.70711 4.79289L0.292893 6.20711ZM6.22701 10.6866L14.727 1.68662L13.273 0.313376L4.77299 9.31338L6.22701 10.6866Z",
    fill: "#71DCA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKvacica);
export default __webpack_public_path__ + "static/media/kvacica.eb981ce2.svg";
export { ForwardRef as ReactComponent };